/*
 * DeadlyScience header layout (sections/ds-header.liquid).
 *
 * Picks one of three layouts from what actually fits:
 *   full    - logo + menu + buttons on one row
 *   stacked - logo + buttons on top, menu on its own row
 *   mobile  - search / logo / cart row, then the Menu · Donate · My Account bar
 *
 * Also keeps the theme's height variables in step with the real header height,
 * and on mobile shifts the sticky header up so only the button bar stays visible.
 */
(function () {
  'use strict';

  var GAP = 24; // matches --ds-group-gap in ds-header.css

  function outerWidth(el) {
    if (!el) return 0;
    var cs = getComputedStyle(el);
    return el.getBoundingClientRect().width + (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0);
  }

  function initHeader(header) {
    if (header.__dsHeader) return;
    header.__dsHeader = true;

    var wrapper = header.closest('[data-header-wrapper]') || header.parentElement;
    var desktop = header.querySelector('[data-ds-desktop]');
    var logo = header.querySelector('[data-ds-logo]');
    var menu = header.querySelector('[data-ds-menu] .header__menu');
    var actions = header.querySelector('[data-ds-actions]');
    var bar = header.querySelector('[data-ds-mobile-bar]');
    var menuToggle = header.querySelector('[data-ds-menu-toggle]');
    var sticky = wrapper && wrapper.hasAttribute('data-header-sticky');
    var frame = null;

    function available() {
      var cs = getComputedStyle(desktop);
      return desktop.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    }

    function menuWidth() {
      if (!menu) return 0;
      var total = 0;
      for (var i = 0; i < menu.children.length; i++) {
        var child = menu.children[i];
        if (child.classList.contains('menu__item')) total += outerWidth(child);
      }
      return total;
    }

    function decide() {
      var W = available();
      var L = outerWidth(logo && logo.firstElementChild);
      var M = menuWidth();
      var A = outerWidth(actions);

      if (L + M + A + GAP * 2 <= W) return 'full';
      if (M <= W && L + A + GAP <= W) return 'stacked';
      return 'mobile';
    }

    function syncHeights(layout) {
      var root = document.documentElement;
      var height = header.getBoundingClientRect().height;
      root.style.setProperty('--header-height', height + 'px');

      if (layout === 'mobile' && bar) {
        var barHeight = bar.getBoundingClientRect().height;
        if (sticky) {
          wrapper.style.setProperty('--ds-stuck-offset', -(height - barHeight) + 'px');
          document.body.style.setProperty('--header-sticky-height', barHeight + 'px');
        }
      } else {
        wrapper.style.removeProperty('--ds-stuck-offset');
        document.body.style.removeProperty('--header-sticky-height');
      }
    }

    function update() {
      frame = null;
      var layout = decide();
      if (header.getAttribute('data-layout') !== layout) {
        header.setAttribute('data-layout', layout);
        if (wrapper) wrapper.setAttribute('data-ds-layout', layout);
      }
      syncHeights(layout);
    }

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(update);
    }

    // Point the Menu button at the side panel for screen readers.
    var drawer = document.querySelector('mobile-menu [data-drawer]');
    if (menuToggle && drawer && drawer.id) menuToggle.setAttribute('aria-controls', drawer.id);

    update();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      ro.observe(desktop);
      if (menu) ro.observe(menu);
      if (actions) ro.observe(actions);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  function initAll() {
    var headers = document.querySelectorAll('[data-ds-header]');
    for (var i = 0; i < headers.length; i++) initHeader(headers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
